import DataGrid, { IColumnProps } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import React from "react";
import { cpCheckBackService, cpCheckBackStore } from "../../api";
import { createEmptyStore, DataMap, dataSources, enums, ModuleConfig } from "../../base";
import { createGridOptions, remoteReadOnlyGridOptions, StdGrid } from "../../components";
import { CpCheckBackModel } from "../../models";

export interface CpCheckBackGridProps {
    deferLoad: boolean;
    permissions: DataMap<boolean>;
    onModelSelected: (model: CpCheckBackModel) => void;
    onRowChecked: (ids: number[]) => void;
    onButtonClick: (model: CpCheckBackModel, name: string) => void;
}

interface CpCheckBackGridState {
    store: CustomStore;
    columns: IColumnProps[];
}

export default class CpCheckBackGrid extends React.Component<CpCheckBackGridProps, CpCheckBackGridState> {
    moduleName: ModuleConfig = {
        moduleName: "CpCheckBack",
        children: {
            "batch": "CpBatch"
        } 
    };

    gridRef = React.createRef<DataGrid>();
    gridOptions = createGridOptions("cpCheckBacks", this.gridRef, remoteReadOnlyGridOptions);

    constructor(props: Readonly<CpCheckBackGridProps>) {
        super(props);

        this.state = {
            store: props.deferLoad ? createEmptyStore() : cpCheckBackStore,
            columns: [
                { dataField: "createdAt", dataType: "datetime" },
                { dataField: "updatedAt", dataType: "datetime" },
                { dataField: "produceDate", dataType: "date" },
                { dataField: "enterDate", dataType: "date" },
                { dataField: "inspectDate", dataType: "date" },
                { dataField: "code" },
                { dataField: "checkCode" },
                { dataField: "barcode" },
                { dataField: "nextInspectDate", dataType: "date" },
                { dataField: "bottleType" },
                { dataField: "vendor" },
                { dataField: "checker" },
                { dataField: "organization" },
                { dataField: "weight" },
                { 
                    dataField: "batch.batchCode",
                    cellRender: (e: any) => (
                        <span>
                            {e.data.batch.batchType === enums.cpBatchTypes.specialCheckBack ? 
                                `无批次（${e.data.batch.batchCode}）` : e.data.batch.batchCode}
                        </span>
                    )
                },
                { 
                    dataField: "status",
                    lookup: { dataSource: dataSources.cpCheckBackStatus, displayExpr: 'text', valueExpr: 'value' }
                },
                { dataField: "note" }
            ]
        }

        this.gridOptions.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.gridOptions.onRowDblClick = (e) => this.props.onButtonClick(e.data, "edit");
    }

    load(batchId: number) {
        this.setState({
            store: cpCheckBackService.getDxData(batchId)
        });
    }

    onSelectionChanged(e: SelectionChangedEvent) {
        if (e.selectedRowsData.length === 1) {
            this.props.onModelSelected(e.selectedRowsData[0]);
        } else {
            this.props.onModelSelected({});    // 为避免混乱，多选不能编辑
        }

        this.props.onRowChecked(e.selectedRowKeys);
    }

    refresh() {
        this.gridRef.current?.instance.refresh();
    }

    render() {
        return (
            <StdGrid
                moduleName={this.moduleName}
                gridRef={this.gridRef}
                dataSource={this.state.store}
                options={this.gridOptions}
                columns={this.state.columns} />
        )
    }
}